module.exports = __webpack_public_path__ + "static/p4-cc039ad8f9da563fb9ec245b265bb1c1.svg";